import { useQuery } from '@tanstack/react-query';

import { getHubspotStatus } from '../api/status';
import type { HubspotStatusResponse } from '../types';

export function useHubspotStatus(orgId: number | string | undefined) {
  return useQuery<HubspotStatusResponse>({
    queryKey: ['hubspotStatus', orgId],
    queryFn: () => {
      if (!orgId) {
        throw new Error('orgId is required');
      }
      return getHubspotStatus(orgId);
    },
    enabled: !!orgId,
    refetchInterval: query => {
      const { data } = query.state;
      if (!data?.connected) {
        return false;
      }
      if (data?.bulk_completed_at == null) {
        return 5000;
      }
      return 30000;
    },
  });
}
